import React from 'react';
import PropTypes from 'prop-types';
import { Icon, IconButton } from '@material-ui/core';
import { CloseIcon } from 'sharedComponents/Icons';
import MainHeader from 'sharedComponents/MainHeader';
import Preloader from 'sharedComponents/Preloader';
import SearchRM from 'sharedComponents/SearchRM';
import GroupList from '../../modules/clients/pages/NewGroupsPage/GroupList';

export const GroupsSearchModal = ({
  getClientGroups,
  fetchGroupClients,
  clientsGroups,
  clientsGroupsLoading,
  classes,
  pageTitle,
  searchLabel,
  onClose,
  onGroupSelected,
  withClients,
}) => {
  const [loading, setLoading] = React.useState(clientsGroupsLoading);
  const [groups, setGroups] = React.useState([]);

  React.useEffect(() => {
    if (!clientsGroups.length) {
      getClientGroups();
    }
  }, []);

  React.useEffect(() => {
    setLoading(clientsGroupsLoading);
  }, [clientsGroupsLoading]);

  React.useEffect(() => {
    setGroups(clientsGroups);
  }, [clientsGroups]);

  const onSearchHandler = (searchValue) => {
    if (!clientsGroups?.length) return;
    const filteredGroups = clientsGroups.filter(({ name }) => name.toLowerCase().includes(searchValue.toLowerCase()));
    setGroups(filteredGroups);
  };

  const onGroupSelectHandler = async (groupId, clientsCount) => {
    if (withClients) {
      setLoading(true);
      const clientsMap = await fetchGroupClients(groupId, { from: 0, size: clientsCount });
      onGroupSelected({ groupId, clients: Object.values(clientsMap) });
      setLoading(false);
    } else {
      onGroupSelected({ groupId });
    }
  };

  const renderTitle = () => (
    <div className={classes.title}>
      <IconButton
        data-testid="close-button"
        edge="start"
        color="inherit"
        classes={{ root: classes.icon }}
        onClick={onClose}
      >
        <Icon component={CloseIcon} fontSize="small" />
      </IconButton>
      <div data-testid="page-title">{pageTitle}</div>
    </div>
  );

  const renderSearch = () => (
    <>
      {searchLabel && <div className={classes.searchLabel}>{searchLabel}</div>}
      <SearchRM
        disabled={loading}
        placeholder="Search groups"
        applySearch={onSearchHandler}
        isHeaderWithin
        withDebounce
      />
    </>
  );

  return (
    <>
      <MainHeader
        classes={{ header: classes.header }}
        customTitle={renderTitle}
        search={renderSearch}
        onClose={onClose}
      />
      <div className={classes.scrollBox}>
        <GroupList groups={groups} redirectToGroupPage={onGroupSelectHandler} />
      </div>
      {loading && <Preloader />}
    </>
  );
};

GroupsSearchModal.propTypes = {
  onClose: PropTypes.func,
  onGroupSelected: PropTypes.func,
  pageTitle: PropTypes.string,
  searchLabel: PropTypes.string,
  classes: PropTypes.objectOf(PropTypes.string),
  clientsGroups: PropTypes.arrayOf(PropTypes.object),
  clientsGroupsLoading: PropTypes.bool,
  withClients: PropTypes.bool,
};

GroupsSearchModal.defaultProps = {
  onGroupSelected: () => {},
  pageTitle: '',
  classes: {},
  clientsGroups: [],
  onClose: () => {},
  clientsGroupsLoading: false,
  withClients: false,
};

export default GroupsSearchModal;
